import { etliveColor, registerColor, supportColor, dashboardColor } from "Icons/index";
import _ from "lodash";

function goToCustomizationSupport(ea) {
  let win = window.open("about:blank", "_blank");
  win.focus();
  win.location.replace(ea.customization_help_desk_url);
}

export default (ea) => {
  return _.compact([
    { category: "", links: [{ path: "/home", label: "sidebar.item.home", icon: dashboardColor }] },
    {
      category: "sidebar.category.analysis",
      links: [
        { path: "/tracemail", label: "sidebar.item.etlive", icon: etliveColor, newFeature: false },
        { path: "/audits", label: "sidebar.item.auditLogs", icon: registerColor },
        ea.customization_help_desk_url && {
          label: "sidebar.item.support",
          icon: supportColor,
          action: () => goToCustomizationSupport(ea),
        },
      ],
    },
  ]);
};
